import styled from 'styled-components'

const PriceLogoContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`

const TuMobileSectionAB = styled.section`
  display: flex;
  flex-direction: column;
`

const FinanceSection = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 7 : 1)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 1;
    margin-top: 16px;
  }
`

const OffersSection = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 1 : 2)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 2;
  }
`

const FreqBroughtTogether = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 2 : 3)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 3;
  }
`

const OrderSwatch = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 3 : 4)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 4;
  }
`

const Availability = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 4 : 5)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 5;
  }
`

const EMWBISSectionAB = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 8 : 6)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 6;
  }
`
const FitSection = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 5 : 7)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 7;
  }
`

const AddToTrolley = styled.section`
  order: ${({ isTuMobileLayout = false }) => (isTuMobileLayout ? 6 : 8)};

  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 8;
  }
`

export {
  TuMobileSectionAB,
  PriceLogoContainer,
  FinanceSection,
  OffersSection,
  FreqBroughtTogether,
  OrderSwatch,
  Availability,
  AddToTrolley,
  EMWBISSectionAB,
  FitSection
} // eslint-disable-line
